import ModalConfirmarAcao from '@/shared/components/modals/ModalProximaAcao';
import ModalNotificacao from '../../modals/ModalNotificacao';
import ModalResponsavel from '../../modals/ModalResponsavel';
import ModalAssinaturas from '../../modals/ModalAssinaturas';
import { ListAllMonthsOfAnIntershipResponseDto, ListAllIntershipsOfTheMonthResponseDto, AttendanceSheetResponseDto } from '@/api.types';

// Adaptador para converter ListAllMonthsOfAnIntershipResponseDto para o formato esperado pelo ModalResponsavel
function adaptToModalResponsavelType(
  item: ListAllMonthsOfAnIntershipResponseDto
): ListAllIntershipsOfTheMonthResponseDto {
  return {
    ano: item.ano,
    mes: item.mes,
    folha: item.folha ? {
      id: item.folha.id,
      liberado: false,
      status: item.status,
      editadoEm: item.folha.editadoem || new Date().toISOString(),
    } : {
      id: '',
      liberado: false,
      status: 0,
      editadoEm: new Date().toISOString(),
    },
    estagiario: item.estagiario ? {
      id: item.estagiario.id,
      nome: item.estagiario.nome || '',
      cpf: '',
    } : {
      id: 0,
      nome: '',
      cpf: '',
    },
    estagio: {
      id: 0,
      unidade: item.unidade?.nome || '',
    },
    responsavel: item.responsavel ? {
      id: item.responsavel.id.toString(),
      nome: item.responsavel.nome,
      cpf: '',
      email: ''
    } : {
      id: '',
      nome: '',
      cpf: '',
      email: ''
    },
  };
}

interface Props {
  folhaSelecionada?: ListAllMonthsOfAnIntershipResponseDto;
  selectedItem?: ListAllMonthsOfAnIntershipResponseDto;
  estagioId?: number;
  showModalResponsavel: boolean;
  setShowModalResponsavel: (v: boolean) => void;
  showModalNotificacaoIndividual: boolean;
  setShowModalNotificacaoIndividual: (v: boolean) => void;
  showModalCriarFolha: boolean;
  setShowModalCriarFolha: (v: boolean) => void;
  isExecuting: boolean;
  handleCriarFolha: () => void;
  estagiarioNome?: string;
  showModalAssinaturas: boolean;
  setShowModalAssinaturas: (v: boolean) => void;
  folhaParaAssinaturas: AttendanceSheetResponseDto | null;
}

export function PerInternModals({
  folhaSelecionada, selectedItem,
  showModalResponsavel, setShowModalResponsavel,
  showModalNotificacaoIndividual, setShowModalNotificacaoIndividual,
  showModalCriarFolha, setShowModalCriarFolha,
  isExecuting, handleCriarFolha,
  estagiarioNome,
  showModalAssinaturas, setShowModalAssinaturas,
  folhaParaAssinaturas,
}: Props) {
  return (
    <>
      {showModalResponsavel && folhaSelecionada && folhaSelecionada.folha && (
        <ModalResponsavel
          show={showModalResponsavel}
          folha={adaptToModalResponsavelType(folhaSelecionada)}
          handleHide={() => setShowModalResponsavel(false)}
        />
      )}

      {showModalNotificacaoIndividual && folhaSelecionada?.folha && (
        <ModalNotificacao
          show={showModalNotificacaoIndividual}
          folha_id={folhaSelecionada.folha.id}
          handleHide={() => setShowModalNotificacaoIndividual(false)}
        />
      )}

      {showModalCriarFolha && selectedItem && (
        <ModalConfirmarAcao
          tituloDaCaixaDeTexto="Criar folha de frequência"
          corpoDaCaixaDeTexto={`Criar folha para ${estagiarioNome || 'o estagiário'} no mês ${selectedItem.mes}/${selectedItem.ano}?`}
          tituloBotaoPrincipal="Criar Folha"
          handleAcaoPrincipal={handleCriarFolha}
          show={showModalCriarFolha}
          executing={isExecuting}
          handleHide={() => setShowModalCriarFolha(false)}
        />
      )}

      <ModalAssinaturas
        show={showModalAssinaturas}
        folha={folhaParaAssinaturas}
        handleHide={() => setShowModalAssinaturas(false)}
      />
    </>
  );
}

